"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getInputClassName = getInputClassName;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.array.concat.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _math = require("../_utils/math");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getInputClassName(prefixCls, disabled, readOnly, size, mSize, width, status, prefix, suffix) {
  var _classnames;
  if (prefix || suffix) {
    return prefixCls;
  }
  return (0, _classnames2.default)(prefixCls, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "is-disabled", disabled), (0, _defineProperty2.default)(_classnames, "is-readOnly", readOnly), (0, _defineProperty2.default)(_classnames, "is-".concat(status), status), (0, _defineProperty2.default)(_classnames, "size-".concat(size), size), (0, _defineProperty2.default)(_classnames, "m-size-".concat(mSize), mSize), (0, _defineProperty2.default)(_classnames, "size-".concat(width, "-width"), width), _classnames));
}
var InputNumber = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var value = _ref.value,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? 0 : _ref$defaultValue,
    min = _ref.min,
    max = _ref.max,
    _ref$precision = _ref.precision,
    precision = _ref$precision === void 0 ? 2 : _ref$precision,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? true : _ref$controls,
    style = _ref.style,
    onChange = _ref.onChange,
    onPressEnter = _ref.onPressEnter,
    onBlur = _ref.onBlur,
    onStep = _ref.onStep;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('inputNumber');
  var comCls = (0, _usePrefixCls.usePrefixCls)('input');
  var _useState = (0, _react.useState)(defaultValue ? Number(defaultValue) : Number(value)),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    innerVal = _useState2[0],
    setInnerVal = _useState2[1];
  (0, _react.useEffect)(function () {
    setInnerVal(Number(value));
  }, [value]);
  (0, _react.useEffect)(function () {
    if (min !== undefined && Number(value) < min) {
      commit(min);
    } else if (max !== undefined && Number(value) > max) {
      commit(max);
    }
  }, [max, min]);
  var commit = function commit(commitVal) {
    setInnerVal(commitVal);
    onChange && onChange(Number(commitVal));
  };
  var verifyBeforeSubmit = (0, _react.useCallback)(function (callback) {
    var curVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : innerVal;
    var NUM_PATTERN = /^-?\d*\.?\d+$/;
    // step 1 validation
    if (!curVal || String(curVal).length === 0 || !NUM_PATTERN.test(String(curVal)) || typeof min === 'number' && Number(curVal) < min ||
    // 越界
    typeof max === 'number' && Number(curVal) > max // 越界
    ) {
      setInnerVal(Number(value));
      return;
    }
    var commitVal = parseFloat(String(curVal)).toFixed(precision);

    // step2 保留两位小数点
    if (typeof min === 'number' && typeof max === 'number' && parseFloat(String(curVal)) > min && parseFloat(String(curVal)) < max) {
      commitVal = parseFloat(String(curVal)).toFixed(precision);
    } else {
      if (typeof min === 'number' && parseFloat(String(curVal)) <= min) {
        commitVal = String(min);
      } else if (typeof max === 'number' && parseFloat(String(curVal)) >= max) {
        commitVal = String(max);
      }
    }

    // step3 commit value
    commit(Number(commitVal));

    // step4 执行回调
    callback && callback(commitVal);
  }, [innerVal, min, max, commit, value, precision]);
  var handleChange = function handleChange(e) {
    setInnerVal(e.target.value);
  };
  var handlePressEnter = (0, _react.useCallback)(function () {
    verifyBeforeSubmit(onPressEnter);
  }, [verifyBeforeSubmit, onPressEnter]);
  var handleBlur = (0, _react.useCallback)(function () {
    verifyBeforeSubmit(onBlur);
  }, [onBlur, verifyBeforeSubmit]);
  var handleStep = (0, _react.useCallback)(function (type) {
    var stepLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    // step1 获取prevCommitVal
    var nextVal = type === 'up' ? Number(innerVal) + stepLength : Number(innerVal) - stepLength;
    var finalVal = parseFloat(String(nextVal)).toFixed(precision);

    // step2 执行回调
    if (typeof min === 'number' && typeof max === 'number' && parseFloat(String(nextVal)) > min && parseFloat(String(nextVal)) < max) {
      if (type === 'up') {
        finalVal = (0, _math.parseFloatPrecision)(nextVal);
      } else {
        finalVal = (0, _math.parseFloatPrecision)(nextVal);
      }
    } else {
      if (typeof min === 'number' && parseFloat(String(nextVal)) <= min) {
        finalVal = String(min);
      } else if (typeof max === 'number' && parseFloat(String(nextVal)) >= max) {
        finalVal = String(max);
      }
    }
    commit(Number(finalVal));
    // onStep && onStep(Number(finalVal))
  }, [onStep, innerVal, min, max, precision]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    var key = e.key;
    switch (key) {
      case 'Enter':
        handlePressEnter && handlePressEnter();
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (e.shiftKey) {
          handleStep('up', 10);
        } else {
          handleStep('up');
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (e.shiftKey) {
          handleStep('down', 10);
        } else {
          handleStep('down');
        }
        break;
      default:
        break;
    }
  }, [handlePressEnter, handleStep]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: style,
    className: "".concat(prefixCls)
  }, /*#__PURE__*/_react.default.createElement("div", null, controls && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(min == undefined ? '' : Number(innerVal) <= min ? 'disabled' : '', " ").concat(prefixCls, "__minus"),
    onClick: function onClick() {
      return handleStep('down');
    }
  }, "-"), /*#__PURE__*/_react.default.createElement("input", {
    className: "".concat(prefixCls, "__input"),
    disabled: disabled,
    type: "number",
    value: innerVal,
    defaultValue: defaultValue,
    min: min,
    max: max,
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleKeyDown
  }), controls && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(max == undefined ? '' : Number(innerVal) >= max ? 'disabled' : '', " ").concat(prefixCls, "__plus"),
    onClick: function onClick() {
      return handleStep('up');
    }
  }, "+")));
});
var _default = exports.default = InputNumber;